// Plan Builder was folded into the Schedule page (2026-08-18): one
// authoring surface (/scheduler/:projectId) with WBS, durations,
// predecessors, activity types, templates, partners and a drag-editable
// chart. This route only redirects so old links / bookmarks keep working.
import React from "react";
import { Redirect, useParams } from "react-router-dom";

export default function PlanBuilderPage() {
  const { projectId } = useParams();
  return <Redirect to={projectId ? `/scheduler/${projectId}` : "/coordination"} />;
}
